"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var parametric_graph_1 = require("@evidenceb/parametric-graph");
var zpdes_1 = __importStar(require("./zpdes"));
var ZpdesHssbgGraph = /** @class */ (function (_super) {
    __extends(ZpdesHssbgGraph, _super);
    /**
     * This is a the class to use if we want to take into account the elements that have been locked
     * by the teacher. It extends the ZpdesHssbg class and overrides the instiating and siampling functions
     * @param parametricGraph : object represting the graph created with the @evidenceb/parametric-graph lib
     */
    function ZpdesHssbgGraph(params, parametricGraph) {
        var _this = _super.call(this, params) || this;
        _this.parametricGraph = parametricGraph;
        var graph_def = _this.params["graph"]["graph"];
        graph_def["current_ssbg"] = graph_def["act_prime"];
        var ssbg_params = _this.params["ZpdesSsbg"];
        ssbg_params["graph_def"] = graph_def;
        var mainSSBG = _this.instantiate_ssbg_graph(graph_def, parametricGraph);
        _this.SSBGs = {};
        _this.SSBGs[_this.main_act] = mainSSBG;
        _this.addSSBG_graph(_this.SSBGs[_this.main_act], graph_def, parametricGraph);
        _this.add_requirements();
        return _this;
    }
    ZpdesHssbgGraph.prototype.lock = function (lockedElements) {
        parametric_graph_1.actualiseLockedElements(this.parametricGraph, lockedElements);
        for (var ID in this.SSBGs) {
            parametric_graph_1.actualiseLockedElements(this.SSBGs[ID].parametricGraph, lockedElements);
            for (var i = 0; i < this.SSBGs[ID].SSB.length; i++) {
                parametric_graph_1.actualiseLockedElements(this.SSBGs[ID].SSB[i].parametricGraph, lockedElements);
            }
        }
    };
    ZpdesHssbgGraph.prototype.unlock = function (unlockedElements) {
        parametric_graph_1.actualiseUnlockedElements(this.parametricGraph, unlockedElements);
        for (var ID in this.SSBGs) {
            parametric_graph_1.actualiseUnlockedElements(this.SSBGs[ID].parametricGraph, unlockedElements);
            for (var i = 0; i < this.SSBGs[ID].SSB.length; i++) {
                parametric_graph_1.actualiseUnlockedElements(this.SSBGs[ID].SSB[i].parametricGraph, unlockedElements);
            }
        }
    };
    ZpdesHssbgGraph.prototype.getModuleStatus = function () {
        var moduleState = this.SSBGs[this.main_act].get_student_diagnostic()["param_state"][0];
        for (var i = 0; i < moduleState.length; i++) {
            if (moduleState[i] == 0) {
                return false;
            }
            else if (moduleState[i] == 1) {
                var objID = this.SSBGs[this.main_act].param_values[0][i];
                var objState = this.SSBGs[objID].get_student_diagnostic()["param_state"][0];
                for (var j = 0; j < objState.length; j++) {
                    if (objState[j] == 0 || objState[j] == 1) {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    ZpdesHssbgGraph.prototype.addSSBG_graph = function (ssbg_father, graph_def, parametricGraph) {
        //let stuffZipped = zip(ssbg_father.param_values, ssbg_father.values_children); //, range(ssbg_father.param_values.length));
        for (var i = 0; i < ssbg_father.param_values.length; i++) {
            var actRT = ssbg_father.param_values[i];
            var hierarchy = ssbg_father.values_children[i];
            //let stuffZipped2 = zip(actRT, hierarchy);
            for (var ii = 0; ii < actRT.length; ii++) {
                var nameRT = actRT[ii];
                var hierar = hierarchy[ii];
                if (hierar && Object.keys(this.SSBGs).includes(nameRT)) {
                    ssbg_father.add_sonSSBG(i, this.SSBGs[nameRT]);
                }
                else if (hierar) {
                    graph_def["current_ssbg"] = nameRT;
                    //let nssbg = this.instantiate_ssbg(graph_def);
                    this.SSBGs[nameRT] = this.instantiate_ssbg_graph(graph_def, parametricGraph);
                    ssbg_father.add_sonSSBG(i, this.SSBGs[nameRT]);
                    this.addSSBG_graph(this.SSBGs[nameRT], graph_def, parametricGraph);
                }
            }
        }
    };
    ZpdesHssbgGraph.prototype.isAnyElementLocked = function () {
        for (var _i = 0, _a = Object.values(this.parametricGraph); _i < _a.length; _i++) {
            var v = _a[_i];
            if (v["status"] == 3) {
                return true;
            }
        }
        return false;
    };
    ZpdesHssbgGraph.prototype.instantiate_ssbg_graph = function (graph_def, parametricGraph) {
        var params = this.params["ZpdesSsbg"];
        params["graph_def"] = graph_def;
        return new ZpdesSsbgGraph(params, parametricGraph);
    };
    return ZpdesHssbgGraph;
}(zpdes_1.default));
exports.default = ZpdesHssbgGraph;
var ZpdesSsbgGraph = /** @class */ (function (_super) {
    __extends(ZpdesSsbgGraph, _super);
    function ZpdesSsbgGraph(params, parametricGraph) {
        var _this = _super.call(this, params) || this;
        _this.parametricGraph = parametricGraph;
        _this.SSB = [];
        for (var ii = 0; ii < _this.nactions; ii++) {
            var ssbParams = _this.params["ZpdesSsb"];
            ssbParams["init_ssb"] = _this.init_ssb[ii];
            ssbParams["requirements"] = _this.requirements[ii];
            ssbParams["min_nb_ans_lp"] = _this.min_nb_ans_lp[ii];
            ssbParams["do_h_promote"] = _this.do_h_promote[ii];
            ssbParams["upZPDval"] = _this.upZPDval[ii];
            ssbParams["deactZPDval"] = _this.deactZPDval[ii];
            ssbParams["stepUpdate"] = _this.stepUpdate[ii];
            ssbParams["stepMax"] = _this.stepMax[ii];
            ssbParams["nbMinStep"] = _this.nbMinStep[ii];
            _this.SSB.push(new ZpdesSsbGraph(ii, _this.ID, _this.nvalue[ii], _this.h_actions[ii], _this.param_values[ii], ssbParams, parametricGraph));
        }
        return _this;
    }
    ZpdesSsbgGraph.prototype.get_student_diagnostic = function () {
        var SSBGdiagnostic = { param_state: [], progression: [] };
        for (var i = 0; i < this.nactions; i++) {
            SSBGdiagnostic["param_state"].push(this.SSB[i].state_bandval);
            for (var j = 0; j < this.SSB[i].SSBdiagnostic.length; j++) {
                SSBGdiagnostic["progression"].push(this.SSB[i].SSBdiagnostic[j]);
            }
        }
        for (var ii = 0; ii < SSBGdiagnostic["param_state"][0].length; ii++) {
            if (this.parametricGraph[this.param_values[0][ii]]["status"] == 3) {
                SSBGdiagnostic["param_state"][0][ii] = 3;
            }
        }
        return SSBGdiagnostic;
    };
    return ZpdesSsbgGraph;
}(zpdes_1.ZpdesSsbg));
var ZpdesSsbGraph = /** @class */ (function (_super) {
    __extends(ZpdesSsbGraph, _super);
    function ZpdesSsbGraph(id, rSSBG, nval, is_h, param_values, params, parametricGraph) {
        var _this = _super.call(this, id, rSSBG, nval, is_h, param_values, params) || this;
        _this.parametricGraph = parametricGraph;
        return _this;
    }
    ZpdesSsbGraph.prototype.count_closed_or_locked = function () {
        var count = 0;
        for (var ii = 0; ii < this.bandval.length; ii++) {
            if (this.bandval[ii] == 0 ||
                this.parametricGraph[this.param_values[ii]]["status"] == 3)
                count++;
        }
        return count;
    };
    ZpdesSsbGraph.prototype.get_probDistrib = function (exploration_coeff) {
        if (exploration_coeff === void 0) { exploration_coeff = 10; }
        if (this.count_closed_or_locked() == this.bandval.length - 1) {
            // TODO: will there be an issue with end of module modification?
            for (var i = 0; i < this.bandval.length; i++) {
                if (this.bandval[i] != 0) {
                    this.bandval[i] = this.uniformval;
                }
            }
        }
        var bandval_cloned = [];
        for (var i = 0; i < this.bandval.length; i++) {
            if (this.parametricGraph[this.param_values[i]]["status"] == 3) {
                bandval_cloned.push(0);
            }
            else {
                bandval_cloned.push(this.bandval[i]);
            }
        }
        /**let norm_v = func_sum(bandval_cloned);*/
        var norm_v = 0;
        var temp_prob = [];
        for (var i = 0; i < bandval_cloned.length; i++) {
            norm_v += bandval_cloned[i];
        }
        for (var i = 0; i < bandval_cloned.length; i++) {
            var nval = 0;
            if (bandval_cloned[i] > 0) {
                nval = bandval_cloned[i] + norm_v / exploration_coeff;
            }
            temp_prob.push(nval);
        }
        var sum_nn = 0;
        for (var i = 0; i < temp_prob.length; i++) {
            sum_nn += temp_prob[i];
        }
        var final_prob = [];
        for (var i = 0; i < temp_prob.length; i++) {
            var nval = temp_prob[i] / sum_nn;
            final_prob.push(nval);
        }
        return final_prob;
    };
    return ZpdesSsbGraph;
}(zpdes_1.ZpdesSsb));
